import { c as _c } from "react/compiler-runtime";
import AlertComponent, { AlertType } from '../alert/alert.component';
import ButtonComponent, { IconSize } from '../button/button/button.component';
import { Dispatch, ReactElement, SetStateAction, useRef, useState } from 'react';
import { AddToCurrentCartFailedError } from '@spa/lib/store/carts/CartsState';
import { ButtonType } from '@spa/components/button/types/ButtonType';
import CartQuantityDropdownComponent from '../cart-quantity-dropdown/cart-quantity-dropdown.component';
import { CustomOrderType } from '@spa/lib/store/carts/CustomOrderType';
import { DetailedStore } from '../storefinder/interfaces';
import ImageComponent from '@spa/components/image-component/image.component';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import { ProductPreOrderSettings } from '@spa/generated/graphql/graphql';
import { ProductQuantityPerCart } from '@spa/lib/store/carts/selectors/createSelectProductQuantityInCarts';
import { StickyBuyRowPosition } from '@spa/components/sticky-buy-button/StickyBuyRowPosition';
import classNames from 'clsx';
import styles from './add-to-cart.component.module.scss';
import { useIntersectionObserver } from 'usehooks-ts';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
import useSelectProductQuantityInCarts from '../../lib/react/hooks/useSelectProductQuantityInCarts';
const stickyBuyRowOffsetTop: number = 12;
const stickyBuyRowOffsetBottom: number = 13;
export interface Props {
  readonly customOrderType: CustomOrderType;
  readonly disabled?: boolean;
  readonly isAddingToCart: boolean;
  readonly onAddToCartClicked: (customOrderType: CustomOrderType, quantity: number, selectedStore?: DetailedStore | null) => void;
  readonly preOrderSettings?: ProductPreOrderSettings | null;
  readonly productCode: string;
  readonly productName: string;
  readonly quantityToBuy: number;
  readonly saleMinimumQuantity: number;
  readonly saleMaximumQuantity: number;
  readonly saleQuantityIncrements: number;
  readonly stockLevel: number;
  readonly setQuantityToBuy: Dispatch<SetStateAction<number>>;
  readonly addToCartFailedReason?: AddToCurrentCartFailedError;
  readonly stickyBuyRowPosition?: StickyBuyRowPosition;
  readonly isWishlistDetails?: boolean;
  readonly setStickyBuyRowPosition?: ((position: StickyBuyRowPosition | null) => void) | null;
  readonly showStoreNotSelectedError: boolean;
}
export default function AddToCartComponent(t0) {
  const $ = _c(80);
  const {
    customOrderType,
    disabled: t1,
    isAddingToCart,
    onAddToCartClicked,
    addToCartFailedReason,
    productCode,
    productName,
    quantityToBuy,
    saleMinimumQuantity,
    saleMaximumQuantity,
    saleQuantityIncrements,
    stockLevel,
    setQuantityToBuy,
    stickyBuyRowPosition,
    isWishlistDetails: t2,
    setStickyBuyRowPosition,
    showStoreNotSelectedError,
    preOrderSettings: t3
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const isWishlistDetails = t2 === undefined ? false : t2;
  const preOrderSettings = t3 === undefined ? null : t3;
  const {
    formatMessage
  } = useNamespacedIntl("add-to-cart");
  const [overSaleMaximumQuantity, setOverSaleMaximumQuantity] = useState(false);
  const quantityInCarts = useSelectProductQuantityInCarts(productCode);
  let totalQtyInCarts;
  let totalQtyInCurrentCart;
  if ($[0] !== customOrderType || $[1] !== quantityInCarts) {
    totalQtyInCarts = 0;
    totalQtyInCurrentCart = 0;
    quantityInCarts.forEach(t4 => {
      const {
        cartType,
        quantity
      } = t4;
      if (cartType === customOrderType) {
        totalQtyInCurrentCart = quantity;
      }
      totalQtyInCarts = totalQtyInCarts + quantity;
      totalQtyInCarts;
    });
    $[0] = customOrderType;
    $[1] = quantityInCarts;
    $[2] = totalQtyInCarts;
    $[3] = totalQtyInCurrentCart;
  } else {
    totalQtyInCarts = $[2];
    totalQtyInCurrentCart = $[3];
  }
  const availableStockLevelToAdd = stockLevel - totalQtyInCarts;
  const maxStockInCart = totalQtyInCarts >= stockLevel;
  const saleMaxQtyInCurrentCart = totalQtyInCurrentCart >= saleMaximumQuantity || addToCartFailedReason === AddToCurrentCartFailedError.ITEM_MAXIMUM_QUANTITY_VALIDATION_FAILED;
  const availableQuantityIsLessThanSaleMinQuantity = availableStockLevelToAdd < saleMinimumQuantity;
  if (quantityToBuy > availableStockLevelToAdd) {
    setQuantityToBuy(availableStockLevelToAdd);
  }
  let t4;
  if ($[4] !== maxStockInCart || $[5] !== saleMaximumQuantity || $[6] !== setQuantityToBuy || $[7] !== totalQtyInCurrentCart) {
    t4 = newQuantity => {
      const saleMaxQtyPerCartExceeded = totalQtyInCurrentCart + newQuantity > saleMaximumQuantity;
      if (saleMaxQtyPerCartExceeded || maxStockInCart) {
        setOverSaleMaximumQuantity(true);
      } else {
        setOverSaleMaximumQuantity(false);
        setQuantityToBuy(newQuantity);
      }
    };
    $[4] = maxStockInCart;
    $[5] = saleMaximumQuantity;
    $[6] = setQuantityToBuy;
    $[7] = totalQtyInCurrentCart;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const setQuantityGuarded = t4;
  let t5;
  if ($[9] !== availableQuantityIsLessThanSaleMinQuantity || $[10] !== formatMessage || $[11] !== maxStockInCart || $[12] !== saleMaxQtyInCurrentCart) {
    t5 = () => {
      let messageKey = maxStockInCart || availableQuantityIsLessThanSaleMinQuantity ? "maxStockInCartMessage" : null;
      if (saleMaxQtyInCurrentCart) {
        messageKey = "exceedingSaleMaximumQuantityMessage";
      }
      return <div className={classNames(styles["add-to-cart__info-text"], "text-s")}>{messageKey && <span>{formatMessage(messageKey)}</span>}</div>;
    };
    $[9] = availableQuantityIsLessThanSaleMinQuantity;
    $[10] = formatMessage;
    $[11] = maxStockInCart;
    $[12] = saleMaxQtyInCurrentCart;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const getInfoMessage = t5;
  const maxReached = overSaleMaximumQuantity || saleMaxQtyInCurrentCart || maxStockInCart || availableQuantityIsLessThanSaleMinQuantity || saleMaximumQuantity === 0;
  const showQuantityDropdown = !disabled && !saleMaxQtyInCurrentCart && !maxStockInCart && !availableQuantityIsLessThanSaleMinQuantity && !isWishlistDetails;
  const showQuantityOptionsOnTop = stickyBuyRowPosition === StickyBuyRowPosition.BOTTOM;
  let t6;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      isOutOfView: false,
      isOutBelow: false
    };
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const outOfViewRef = useRef(t6);
  let t7;
  if ($[15] !== disabled || $[16] !== maxReached || $[17] !== setStickyBuyRowPosition) {
    t7 = () => {
      if (!setStickyBuyRowPosition) {
        return;
      }
      const {
        isOutOfView,
        isOutBelow
      } = outOfViewRef.current;
      let position = null;
      if (!disabled && !maxReached) {
        if (isOutOfView) {
          position = StickyBuyRowPosition.TOP;
        } else {
          if (isOutBelow) {
            position = StickyBuyRowPosition.BOTTOM;
          }
        }
      }
      setStickyBuyRowPosition(position);
    };
    $[15] = disabled;
    $[16] = maxReached;
    $[17] = setStickyBuyRowPosition;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const updateStickyBuyRowPosition = t7;
  let t8;
  if ($[19] !== updateStickyBuyRowPosition) {
    t8 = {
      threshold: 1,
      rootMargin: `-${stickyBuyRowOffsetTop}px 0px 10000px 0px`,
      freezeOnceVisible: false,
      onChange: isIntersecting => {
        outOfViewRef.current.isOutOfView = !isIntersecting;
        updateStickyBuyRowPosition();
      }
    };
    $[19] = updateStickyBuyRowPosition;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const {
    ref: observeOutOfView
  } = useIntersectionObserver(t8);
  let t9;
  if ($[21] !== updateStickyBuyRowPosition) {
    t9 = {
      threshold: 1,
      rootMargin: `10000px 0px -${stickyBuyRowOffsetBottom}px 0px`,
      freezeOnceVisible: false,
      onChange: isIntersecting_0 => {
        outOfViewRef.current.isOutBelow = !isIntersecting_0;
        updateStickyBuyRowPosition();
      }
    };
    $[21] = updateStickyBuyRowPosition;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  const {
    ref: observeOutBelow
  } = useIntersectionObserver(t9);
  let t10;
  if ($[23] !== observeOutBelow || $[24] !== observeOutOfView) {
    t10 = element => {
      observeOutOfView(element);
      observeOutBelow(element);
    };
    $[23] = observeOutBelow;
    $[24] = observeOutOfView;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  const ref = t10;
  const isPreOrderProduct = preOrderSettings !== null;
  const isPreOrderActive = preOrderSettings?.isActive ?? false;
  let t11;
  if ($[26] !== formatMessage || $[27] !== isPreOrderActive) {
    t11 = isPreOrderActive ? formatMessage("preOrderNow") : formatMessage("preOrderNotAvailable");
    $[26] = formatMessage;
    $[27] = isPreOrderActive;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  const preOrderTranslation = t11;
  let t12;
  if ($[29] !== formatMessage || $[30] !== isPreOrderProduct || $[31] !== preOrderTranslation) {
    t12 = isPreOrderProduct ? preOrderTranslation : formatMessage("addToCart");
    $[29] = formatMessage;
    $[30] = isPreOrderProduct;
    $[31] = preOrderTranslation;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  const addToCartTranslation = t12;
  const shouldBeDisabled = disabled || isAddingToCart || maxReached || isPreOrderProduct && !isPreOrderActive;
  let t13;
  if ($[33] !== availableStockLevelToAdd || $[34] !== formatMessage || $[35] !== maxReached || $[36] !== productCode || $[37] !== productName || $[38] !== quantityToBuy || $[39] !== saleMaximumQuantity || $[40] !== saleMinimumQuantity || $[41] !== saleQuantityIncrements || $[42] !== setQuantityGuarded || $[43] !== showQuantityDropdown || $[44] !== showQuantityOptionsOnTop || $[45] !== stockLevel || $[46] !== totalQtyInCurrentCart) {
    t13 = showQuantityDropdown && <CartQuantityDropdownComponent id={`${productCode}-dropdown`} aria-label={formatMessage("changeQuantity", {
      productName
    })} quantity={quantityToBuy} stockLevel={availableStockLevelToAdd} onQuantityChange={setQuantityGuarded} disabled={maxReached} minimumQuantity={saleMinimumQuantity} maximumQuantity={(stockLevel < saleMaximumQuantity ? stockLevel : saleMaximumQuantity) - totalQtyInCurrentCart} quantityIncrements={saleQuantityIncrements} showOptionsOnTop={showQuantityOptionsOnTop} dataTrackId="addToBasketQuantity" dataTestId="pdp-quantity-dropdown" />;
    $[33] = availableStockLevelToAdd;
    $[34] = formatMessage;
    $[35] = maxReached;
    $[36] = productCode;
    $[37] = productName;
    $[38] = quantityToBuy;
    $[39] = saleMaximumQuantity;
    $[40] = saleMinimumQuantity;
    $[41] = saleQuantityIncrements;
    $[42] = setQuantityGuarded;
    $[43] = showQuantityDropdown;
    $[44] = showQuantityOptionsOnTop;
    $[45] = stockLevel;
    $[46] = totalQtyInCurrentCart;
    $[47] = t13;
  } else {
    t13 = $[47];
  }
  let t14;
  if ($[48] !== getInfoMessage || $[49] !== isWishlistDetails || $[50] !== maxReached) {
    t14 = maxReached && !isWishlistDetails && <AlertComponent alertType={AlertType.INFO} content={getInfoMessage()} borderless={true} centeredAlignment={true} />;
    $[48] = getInfoMessage;
    $[49] = isWishlistDetails;
    $[50] = maxReached;
    $[51] = t14;
  } else {
    t14 = $[51];
  }
  let t15;
  if ($[52] !== customOrderType) {
    t15 = classNames(styles["add-to-cart__cart-button"], customOrderType);
    $[52] = customOrderType;
    $[53] = t15;
  } else {
    t15 = $[53];
  }
  let t16;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      src: "/assets/icons/shopping-bag-icon-white.svg",
      alt: "cart-icon",
      width: 16,
      height: 20,
      unoptimized: true
    };
    $[54] = t16;
  } else {
    t16 = $[54];
  }
  let t17;
  if ($[55] !== customOrderType || $[56] !== maxStockInCart || $[57] !== onAddToCartClicked || $[58] !== quantityToBuy) {
    t17 = () => {
      if (!maxStockInCart) {
        onAddToCartClicked(customOrderType, quantityToBuy);
      }
    };
    $[55] = customOrderType;
    $[56] = maxStockInCart;
    $[57] = onAddToCartClicked;
    $[58] = quantityToBuy;
    $[59] = t17;
  } else {
    t17 = $[59];
  }
  let t18;
  if ($[60] !== addToCartTranslation || $[61] !== isAddingToCart || $[62] !== productCode || $[63] !== shouldBeDisabled || $[64] !== t17) {
    t18 = <ButtonComponent buttonType={ButtonType.PRIMARY} iconLeft={t16} iconSize={IconSize.EXTRA_SMALL} showSpinner={isAddingToCart} disabled={shouldBeDisabled} text={addToCartTranslation} onClick={t17} aria-label={addToCartTranslation} dataTrackId="addToCartPDP" dataTestId="pdp-addToCart-button" dataProductId={productCode} />;
    $[60] = addToCartTranslation;
    $[61] = isAddingToCart;
    $[62] = productCode;
    $[63] = shouldBeDisabled;
    $[64] = t17;
    $[65] = t18;
  } else {
    t18 = $[65];
  }
  let t19;
  if ($[66] !== t15 || $[67] !== t18) {
    t19 = <div className={t15}>{t18}</div>;
    $[66] = t15;
    $[67] = t18;
    $[68] = t19;
  } else {
    t19 = $[68];
  }
  let t20;
  if ($[69] !== t13 || $[70] !== t14 || $[71] !== t19) {
    t20 = <div className={styles["add-to-cart__actions"]}>{t13}{t14}{t19}</div>;
    $[69] = t13;
    $[70] = t14;
    $[71] = t19;
    $[72] = t20;
  } else {
    t20 = $[72];
  }
  let t21;
  if ($[73] !== formatMessage || $[74] !== showStoreNotSelectedError) {
    t21 = showStoreNotSelectedError && <div className={`${styles["add-to-cart__warning"]} text-s`}><ImageComponent src="/assets/icons/warning.svg" alt={formatMessage("warning")} width={24} height={24} />{formatMessage("pleaseSelectStoreError")}</div>;
    $[73] = formatMessage;
    $[74] = showStoreNotSelectedError;
    $[75] = t21;
  } else {
    t21 = $[75];
  }
  let t22;
  if ($[76] !== ref || $[77] !== t20 || $[78] !== t21) {
    t22 = <div className={styles["add-to-cart"]} ref={ref}>{t20}{t21}</div>;
    $[76] = ref;
    $[77] = t20;
    $[78] = t21;
    $[79] = t22;
  } else {
    t22 = $[79];
  }
  return t22;
}